import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ChakraProvider, extendTheme, ColorModeScript} from "@chakra-ui/react"
import { BrowserRouter as Router } from 'react-router-dom';
import GA4RouteChangeTracker from './components/GA4RouteChangeTracker';

const config = 
{
  initialColorMode: "dark",
  useSystemColorMode: false
}

const customTheme = extendTheme({ config });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ColorModeScript initialColorMode={customTheme.config.initialColorMode}/>
    <ChakraProvider theme={customTheme}>
      <Router>
        <GA4RouteChangeTracker />    
        <App />
      </Router>
    </ChakraProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
